import { render, staticRenderFns } from "./SalesReportSortByDirection.vue?vue&type=template&id=04fad3ac&"
import script from "./SalesReportSortByDirection.vue?vue&type=script&lang=ts&"
export * from "./SalesReportSortByDirection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports